import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { useRoot } from 'context/RootContext';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, HTTP_VERBS } from 'utils/constants';

const useVoidTicket = id => {
  const path = `/carts/tickets/${id}/cancel`;
  const { t } = useTranslation(LOCALIZATION_PAGES.TICKET_CANCELATION);
  const { showNotification } = useRoot();
  const [{ result, loading, error }, voidTicket] = useApi(path, {
    initialFetch: false,
    verb: HTTP_VERBS.PUT,
  });

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('ticket_void_fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (result) {
      showNotification({
        message: t('ticket_void_success'),
      });
    }
  }, [result, showNotification, t]);

  return [{ result, loading }, voidTicket];
};

export default useVoidTicket;
